import React from 'react';
import react from '../../images/react.png';
import javascriptEs6 from '../../images/javascript-es6.jpeg';
import javascriptInterview from '../../images/javascript-interview.png';
import javascriptInteresting from '../../images/javascript-Tricks.jpeg';
import AllBlog from './AllBlog';

const Blog = () => {
  const blogs = [
    {
      title: '10 Interesting topics in JavaScript',
      img: javascriptInteresting,
      link: 'https://medium.com/@mahfuz-alam/10-javascript-topics-everyone-must-know-it-795907be9f58',
    },
    {
      title: 'React Core Concepts',
      img: react,
      link: 'https://medium.com/@mahfuz-alam/10-important-tropics-everyone-must-be-know-it-about-react-9da635461f40',
    },
    {
      title: 'Upgrade your JavaScript Skill ES6',
      img: javascriptEs6,
      link: 'https://medium.com/@mahfuz-alam/es6-javascript-topics-everyone-must-know-it-9e6f5851986a',
    },
    {
      title: 'Javascript Interview Preparation',
      img: javascriptInterview,
      link: 'https://medium.com/@mahfuz-alam/javascript-interview-question-everyone-know-it-155378719c97',
    },
  ];
  return (
    <div className='section'>
      <div className='container'>
        <h1 className='text-center font-details-b pb-4 text-info fw-bold'>Blogs</h1>
        <div className='row text-center '>
          {blogs.map((blog) => (
            <AllBlog blog={blog}></AllBlog>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
